import React from 'react';
import { DrawnMark } from '@ofself/shell';
import { NUCLEUS_SVG, nucleusFigure } from './marks/nucleus';

// THE NUCLEUS MARK in the kit's drawing engine (DrawnMark), like every app's
// figure: drawn for its size (marks/nucleus.js), animated by the splash.
export default function NucleusMark({ size = 34, title, className = '', ...rest }) {
    return (
        <span className={`nx-mark ${className}`} style={{ width: size, height: size, display: 'inline-block' }} role={title ? 'img' : undefined} aria-label={title || undefined}>
            <DrawnMark svg={nucleusFigure(size)} {...rest} />
        </span>
    );
}

// the splash's figure: the whole mark, which the splash draws in from the self outward
export function NucleusSplashMark(props) {
    return <DrawnMark svg={NUCLEUS_SVG} {...props} />;
}
